import { IDashRegistrationLog } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, Form, FormGroup, Modal, Panel, Row } from 'react-bootstrap';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

const FormWrapper = styled(Form)`
    .form-group {
        margin-bottom: 5px;
    }
`;

interface IProps {
    show: boolean,
    data: IDashRegistrationLog,
    onDelete: () => void,
    onCancel: () => void
}

const DeleteLogEntryConfirmation = (props: IProps) => {
    if (props.data == null)
        return null;

    return (
        <Panel>
            <Panel.Heading>
                Delete Log Entry?
            </Panel.Heading>
            <Panel.Body>
                <Alert bsStyle='danger' style={{ marginBottom: 10, paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>Are you sure you want to delete the following log entry?</Alert>

                <FormWrapper horizontal style={{ paddingLeft: 10 }}>
                    <FormGroup>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Created:</Col>
                        <Col xs={12} lg={9}>
                            <div className='form-control-static'>{props.data.logDateTimeForDisplay}</div>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Created By:</Col>
                        <Col xs={12} lg={9}>
                            <div className='form-control-static'>{props.data.createdByFullName}</div>
                        </Col>
                    </FormGroup>

                    {props.data.updateDateTimeForDisplay != '' && (
                        <>
                            <FormGroup>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated:</Col>
                                <Col xs={12} lg={9}>
                                    <div className='form-control-static'>{props.data.updateDateTimeForDisplay}</div>
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated By:</Col>
                                <Col xs={12} lg={9}>
                                    <div className='form-control-static'>{props.data.updatedByFullName}</div>
                                </Col>
                            </FormGroup>
                        </>
                    )}

                    <FormGroup>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Action Taken:</Col>
                        <Col xs={12} lg={9}>
                            <div className='form-control-static'>{props.data.actionTaken}</div>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Comments:</Col>
                        <Col xs={12} lg={9}>
                            <div className='form-control-static'>{ReactHtmlParser(props.data.comments.replace(/(?:\r\n|\r|\n)/g, '<br/>'))}</div>
                        </Col>
                    </FormGroup>
                </FormWrapper>
            </Panel.Body>
            <Panel.Footer>
                <Button bsStyle='danger' onClick={props.onDelete}>Delete</Button>
                <Button bsStyle='link' onClick={props.onCancel}>Cancel</Button>
            </Panel.Footer>
        </Panel>
    );
}

export default DeleteLogEntryConfirmation;